import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Search from './SearchComponent';
const SearchPage = () => {
    const [searchParams] = useSearchParams();
    const q = searchParams.get('q');
    return (_jsx(Search, { searchTerm: q }));
};
export default observer(SearchPage);
//# sourceMappingURL=SearchPage.js.map